module.exports = __webpack_public_path__ + "static/arrow-0c6696c8c3d03ba5c726cc788847c1c2.png";